
import { applicantStore } from '@/store'
import { ValidationObserver } from 'vee-validate'
import { ValidationError } from '@/commons/types'
import { Component, Prop } from 'vue-property-decorator'
import Checkbox from '@/commons/components/core/Checkbox.vue'
import { translateValidationError } from '@/commons/configuration/vee.validate'

import {
    validatorIds,
    ApplicationValidationFieldName
} from '@/commons/constants/application'
import { ENVIRONMENT } from '@/commons/configuration'

@Component({
    components: {
        Checkbox
    }
})
export default class CertificationApproval extends ValidationObserver {
    @Prop() checkBoxLabelTranslationKey!: string

    domValidatorIds = validatorIds
    termsAndConditionsValidationId = ApplicationValidationFieldName.CONFIRMED_CONDITIONS

    get confirmedConditions (): boolean {
        return applicantStore.getApplication.confirmedConditions
    }

    setConfirmedCondition (isConfirmed: boolean): void {
        applicantStore.getApplication.confirmedConditions = isConfirmed
    }

    get termsAndConditionsUrl (): string {
        return ENVIRONMENT.certificationTermsOfConditionsUrl[this.$i18n.locale]
    }

    translateError (validationError: ValidationError): string {
        return translateValidationError(validationError)
    }
}
